<template>
  <b-navbar type="is-mycolor">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img
          src="../assets/images/dpng.svg"
          alt="Дирекција за изградњу општине Параћин"
        />
      </b-navbar-item>
      <!-- <b-navbar-item tag="router-link" to="/"
        >Сајт дирекција за иѕграднју општине параћин</b-navbar-item
      > -->
      <div style="width: 120px;"></div>
    </template>
    <template slot="start" style="flex-grow: 1; justify-content: center;">
      <b-navbar-item tag="router-link" to="/">Почетна</b-navbar-item>
      <b-navbar-dropdown label="О нама">
        <b-navbar-item tag="router-link" to="/vesti">Вести</b-navbar-item>
        <b-navbar-item tag="router-link" to="/javne-nabavke"
          >Јавне набавке</b-navbar-item
        >

        <b-navbar-item tag="router-link" to="/programi">Програми</b-navbar-item>
        <b-navbar-item tag="router-link" to="/izvestaji"
          >Извештаји</b-navbar-item
        >
        <b-navbar-item tag="router-link" to="/organizacija"
          >Ораганизација</b-navbar-item
        >
      </b-navbar-dropdown>

      <b-navbar-dropdown label="Паркинг сервис">
        <b-navbar-item
          v-show="false"
          tag="router-link"
          to="/kupovina?step=0&vrsta_karte=DK"
          >E-дневна паркинг карта</b-navbar-item
        >
        <b-navbar-item
          v-show="false"
          tag="router-link"
          to="/kupovina?step=0&vrsta_karte=PK"
          >E-месечна претплата</b-navbar-item
        >
        <b-navbar-item tag="router-link" to="/automati">Аутомати</b-navbar-item>
        <b-navbar-item tag="router-link" to="/zone-parkiranja"
          >Зоне паркирања</b-navbar-item
        >
        <b-navbar-item tag="router-link" to="/uklonjena-vozila"
          >Уклоњена возила</b-navbar-item
        >
        <!-- <b-navbar-item tag="router-link" to="/parking-servis"
          >Ценовник</b-navbar-item
        > -->
      </b-navbar-dropdown>

      <b-navbar-item tag="router-link" to="/cenovnici">Ценовници</b-navbar-item>
      <!-- <b-navbar-item tag="router-link" to="/about">About</b-navbar-item> -->
      <!-- uklonjeno na zahtev nidze 29.12.2021 -->
      <!-- <b-navbar-item
        tag="a"
        href="http://www.smartcon.rs/Customers/oupn/ZimskoOdrzavanje.html"
        >Зимска служба</b-navbar-item
      > -->
    </template>

    <template slot="end">
      <b-navbar-item tag="div">
        <div class="buttons">
          <router-link to="/login" class="button" v-show="!loggedIn"
            ><strong>Пријава</strong></router-link
          >
          <a class="button" @click.prevent="onLogout" v-show="loggedIn">
            <strong>Одјава</strong>
          </a>
        </div>

        <!-- <div class="block">
          <b-icon pack="fas" icon="home" size="is-small"> </b-icon>
        </div> -->
      </b-navbar-item>
      <b-navbar-item tag="div" v-show="false">
        <router-link
          :to="{ path: '/kupovina', query: { step: '1' } }"
          v-show="true"
          ><b-icon
            pack="fas"
            icon="shopping-cart"
            size="is-medium"
            type="is-black"
          >
          </b-icon
          ><span class="has-text-black">({{ korpa.length }})</span></router-link
        >
      </b-navbar-item>
    </template>
  </b-navbar>
</template>
<script>
import { mapState } from 'vuex'

export default {
  //name: 'NavBar',
  methods: {
    onLogout() {
      //console.log('onLogout')
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'Home' })
      })
    }
  },
  computed: {
    // navbarMenuVisible() {
    //   return this.$store.auth.state.loggedIn
    // },
    // ----------------------------------
    // moze ovako
    // ...mapState({
    //   loggedIn: state => state.auth.loggedIn,
    //   userData: state => state.auth.userData
    // })
    // ili ovako
    ...mapState('auth', ['loggedIn', 'userData']),
    ...mapState('placanje', ['korpa'])
  }
}
</script>
